import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import classNames from 'classnames';
import SubString from 'add-ellipsis';
import RaisedButton from 'material-ui/RaisedButton';
import { change, Field, reduxForm, reset } from 'redux-form';
import Alert from 'react-s-alert';

import { PatientSkillAcqActiveProgramList, OpenTargetCheck, SetProgramIDs, resetProgramAndTarget, SetProgramIDsForSkillAcqTargetAction } from './actions/programsActions';
import { getTargetsAndProgramsData } from '../../../../../../../scheduling/components/SessionNotes_EBS/actions/soapActions';
import { renderCheckBox, renderTextField } from '../../../../../../../../components/reduxFields';
import SortingCustom from '../../../../../../../../components/SortingCustom';
import PaginatorCustom from '../../../../../../../../components/paginationCustom';
// import SkillAcqActiveTargets from '../targets/target';
import SkillAcqActiveTargetsNewFlow from '../targets/targetNewFlow';
import Tooltip from '../../../../../../../../components/Tooltip';
import { resetFiltersAndSorting } from '../../../../../../../../actions/utilAction';

const stylescss = {
    checkbox: {
        marginBottom: 16,
    },
};

class SkillAcqActivePrograms extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientId: props.patientId ? props.patientId : null,
            selectedSkillAcuActiveProgramsIds: [],
            activePrograms: [],
            selectedActiveProgramIds: []
        }
        this.filter = {
            sort_Column: '',
            sort_Order: '',
            searchText: '',
        };                
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
        this.handleResetButton = this.handleResetButton.bind(this);
        this.handleNewRequest = this.handleNewRequest.bind(this);
    }

    componentDidMount = () => {
        this.loadData();
        this.props.getTargetsAndProgramsData(this.state.patientId);
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            activePrograms: nextProps.masterPatientPrograms,
        });
    }

    loadData = (page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_Order || '',
            contain_filters: { searchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        this.props.PatientSkillAcqActiveProgramList(searchObj, this.state.patientId, this.state.selectedActiveProgramIds)
    }

    setSortColumn = (col_name, col_order) => {        
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;
            this.loadData();
        }
    }

    checkAllSkillAcqActivePrograms = (e) => {
        let isAllSkillAcuActiveProgramsChecked = e.target.checked;
        let skillAcuActiveProgramsData = this.props.patientSkillAcqActiveProgramList.data !== undefined && this.props.patientSkillAcqActiveProgramList.data;
        let selectedSkillAcuActiveProgramsIds = [];
        skillAcuActiveProgramsData.forEach((obj, index) => {
            let skillAcuActiveProgramsIdCheck = `CheckSkillAcqActivePrograms[${index}].Chk`;
            if (obj && isAllSkillAcuActiveProgramsChecked) {
                selectedSkillAcuActiveProgramsIds.push(obj.skillsAcquisitionProgramId);
                this.props.dispatch(change('SkillAcqActiveProgramsForm', skillAcuActiveProgramsIdCheck, true));
            } else {
                this.props.dispatch(change('SkillAcqActiveProgramsForm', skillAcuActiveProgramsIdCheck, false));
            }
        })
        this.setState({
            selectedSkillAcuActiveProgramsIds: selectedSkillAcuActiveProgramsIds,
        });
    }

    checkSkillAcqActivePrograms = (e, index, obj) => {
        let selectedSkillAcuActiveProgramsIds = this.state.selectedSkillAcuActiveProgramsIds;
        let isSkillAcuActiveProgramChecked = e.target.checked;
        if (isSkillAcuActiveProgramChecked) {
            if (obj.skillsAcquisitionProgramId) {
                selectedSkillAcuActiveProgramsIds.push(obj.skillsAcquisitionProgramId);
            }
        } else {
            if (obj.skillsAcquisitionProgramId) {
                index = selectedSkillAcuActiveProgramsIds.findIndex((value) => value === obj.skillsAcquisitionProgramId);
                if (index >= 0) {
                    selectedSkillAcuActiveProgramsIds.splice(index, 1);
                }
            }
        }
        this.setState({
            selectedSkillAcuActiveProgramsIds: selectedSkillAcuActiveProgramsIds
        });
    }

    handleOpen = () => {
        this.props.dispatch(OpenTargetCheck(true));
        this.props.dispatch(SetProgramIDs(this.state.selectedSkillAcuActiveProgramsIds))
        this.props.dispatch(SetProgramIDsForSkillAcqTargetAction(this.state.selectedSkillAcuActiveProgramsIds)) // For Application State Management
    }

    handleBack = () => {
        this.filter.searchText = '';
        this.setState({
            selectedSkillAcuActiveProgramsIds: [],
            selectedActiveProgramIds: [] 
        }, () => this.loadData());
        this.props.dispatch(reset('SkillAcqActiveProgramsForm'))
        this.props.dispatch(resetProgramAndTarget())
    }

    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
          this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
          this.loadData();
        }
    }

    handleResetButton() {
        Alert.closeAll();
        this.props.dispatch(reset('SkillAcqActiveProgramsForm'))        
        resetFiltersAndSorting(this.filter, 'id', true);
        this.setState({
            selectedActiveProgramIds : []
        }, () =>  this.loadData())        
    }    

    handleSubmitSearch() {
        return false;
    }

    handleNewRequest(input, value) {          
        input.onChange(value);
        this.setState({
            selectedActiveProgramIds : value
        }, () =>  this.loadData())
    }

    renderData = (patientSkillAcqActiveProgramList) => {
        patientSkillAcqActiveProgramList = patientSkillAcqActiveProgramList || [];
        if (!patientSkillAcqActiveProgramList.length) {
            return (
                <tr>
                    <td colSpan="3">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return patientSkillAcqActiveProgramList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>
                        <div className="table_custom-check">
                            <Field
                                name={`CheckSkillAcqActivePrograms[${index}].Chk`}
                                component={renderCheckBox}
                                onChange={(e) => this.checkSkillAcqActivePrograms(e, index, Obj)}
                                style={stylescss.checkbox}
                            />
                        </div>
                    </td>
                    <td>{Obj.programName}</td>                    
                    <td>
                        {Obj.programInstructions && Obj.programInstructions.length > 0 ?
                        <Tooltip Description={Obj.programInstructions} />
                        : null}
                        {Obj.programInstructions != null && Obj.programInstructions.length > 25 ? SubString(Obj.programInstructions, 25) : Obj.programInstructions != null ? Obj.programInstructions : 'N/A'}
                    </td>
                </tr>
            )
        })
    }

    renderSkillAcqActiveProgramsTabs = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { patientSkillAcqActiveProgramList } = this.props;
        let PatientSkillAcqActiveProgramList = (patientSkillAcqActiveProgramList && patientSkillAcqActiveProgramList.data) || [];
        let PatientSkillAcqActiveProgramMeta = (patientSkillAcqActiveProgramList && patientSkillAcqActiveProgramList.meta) || null
        return (            
            <div className="table-responsive mt-15">
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="10%">
                                <div className="table_custom-check">
                                    <Field
                                        name='checkSkillAcqActivePrograms'
                                        component={renderCheckBox}
                                        onChange={(e) => this.checkAllSkillAcqActivePrograms(e)}
                                        style={stylescss.checkbox}
                                    />
                                    <span>&nbsp;</span>
                                </div>
                            </th>
                            <th width="50%"><SortingCustom noSort={!PatientSkillAcqActiveProgramList.length} setSortColumn={this.setSortColumn} columnName='programName' displayName='Program Name' /></th>
                            <th width="40%">Program Instructions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData(PatientSkillAcqActiveProgramList)}
                    </tbody>
                </table>
                {
                    PatientSkillAcqActiveProgramMeta && PatientSkillAcqActiveProgramMeta['totalPages']
                        ?
                        <PaginatorCustom data={PatientSkillAcqActiveProgramMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                        :
                        null
                }
            </div>                        
        )
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>     
            {this.props.openTarget === false ?
            <div>                 
                <div className="row mt-3">
                    <div className="col-sm-5">                                             
                        <RaisedButton disabled={this.state.selectedSkillAcuActiveProgramsIds.length > 0 ? false : true}                            
                        label="Start Session"
                        primary={true}
                        onTouchTap={() => this.handleOpen()} />                    
                    </div>
                    <div className="col-sm-7">
                        <div className="row end-flex">
                            <div className="col-sm-6 mtm-27">
                                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSubmitSearch)} >
                                <Field
                                    name="Name"
                                    floatingLabelText="Search"
                                    maxLength="10"
                                    onChange={this.handleSearchChange}
                                    component={renderTextField}
                                    fullWidth={true}
                                />
                                {/* <Field
                                    name="Name"
                                    label="program"
                                    handleNewRequest={this.handleNewRequest}
                                    options={this.state.activePrograms}
                                    component={renderAutoCompleteScheduling}
                                    fullWidth={true}
                                /> */}
                                </form>
                            </div>
                            <div className="reset-btn col-sm-3">
                                <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton} >Reset</RaisedButton>
                            </div>
                        </div>
                    </div>
                </div>     
                <div className="row mt-3">
                    <div className="col-sm-12">
                        {this.renderSkillAcqActiveProgramsTabs()}                  
                    </div>
                </div>
            </div>  
            :
                <div>
                    {/* {this.props.agencyName.toUpperCase() === VIP ? */}
                    <SkillAcqActiveTargetsNewFlow
                        uuid={this.props.uuid}
                        patientId={this.state.patientId}
                        options={this.state.activePrograms}
                        creadteDate={moment().utc().format('YYYY-MM-DDTHH:mm:ss')}
                        handleBack={() => this.handleBack()} 
                        addPermissionSkillAquisition = {this.props.addPermissionSkillAquisition}
                        updatePermissionSkillAquisition = {this.props.updatePermissionSkillAquisition}
                        deletePermissionSkillAquisition =  {this.props.deletePermissionSkillAquisition}
                    />
                    {/* :
                    <SkillAcqActiveTargets
                        uuid={this.props.uuid}
                        patientId={this.state.patientId}
                        options={this.state.activePrograms}
                        creadteDate={moment().utc().format('YYYY-MM-DDTHH:mm:ss')}
                        handleBack={() => this.handleBack()} 
                    /> } */}
                </div>
            }    
            </div>
        );
    }
}

SkillAcqActivePrograms = reduxForm({
    form: 'SkillAcqActiveProgramsForm',
})(SkillAcqActivePrograms);


function mapStateToProps(state) {
    let masterPatientPrograms = [];

    if (state.soap.targetsAndProgramsData) {
        masterPatientPrograms = state.soap.targetsAndProgramsData.data.Programs || [];
    }
    return {
        loading: state.patientSkillAcqActiveProgram.loading,
        patientSkillAcqActiveProgramList: state.patientSkillAcqActiveProgram.patientSkillAcqActiveProgramList,
        uuid: state.patientSkillAcqActiveProgram.uuid,
        openTarget: state.patientSkillAcqActiveProgram.openTarget,
        masterPatientPrograms: masterPatientPrograms,
        agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    }
}

export default connect(mapStateToProps, { PatientSkillAcqActiveProgramList, OpenTargetCheck, SetProgramIDs,SetProgramIDsForSkillAcqTargetAction, resetProgramAndTarget, getTargetsAndProgramsData })(SkillAcqActivePrograms)



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Maintenance/components/programs/program.js